import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchBoxComponent } from './search-box.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { HighlightSearchTermPipe } from './highlightSearchTerm.pipe';
import { SearchInputComponent } from './search-input/search-input.component';
import { MaterialDesignModule } from '../material-design/material-design.module';

@NgModule( {
  imports: [ReactiveFormsModule, CommonModule, FormsModule, MaterialDesignModule],
  declarations: [SearchBoxComponent, HighlightSearchTermPipe, SearchInputComponent],
  providers: [FormsModule],
  exports: [SearchBoxComponent, HighlightSearchTermPipe, SearchInputComponent]
})

export class SearchProductsModule {}



// WEBPACK FOOTER //
// /app/src/app/shared/search-products/search-products.module.ts